import { render, staticRenderFns } from "./CategoryMenu.vue?vue&type=template&id=86587be4&scoped=true&"
import script from "./CategoryMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenu.vue?vue&type=style&index=0&id=86587be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86587be4",
  null
  
)

export default component.exports